import { render, staticRenderFns } from "./departMember.vue?vue&type=template&id=1772a2e9&scoped=true&"
import script from "./departMember.vue?vue&type=script&lang=js&"
export * from "./departMember.vue?vue&type=script&lang=js&"
import style0 from "./departMember.vue?vue&type=style&index=0&id=1772a2e9&prod&scoped=true&lang=css&"
import style1 from "./departMember.vue?vue&type=style&index=1&id=1772a2e9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1772a2e9",
  null
  
)

export default component.exports